/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Page_OverlineInputs */

const en_serve_page_overline = /** @type {(inputs: Serve_Page_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your own subscription`)
};

const id_serve_page_overline = /** @type {(inputs: Serve_Page_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langganan sendiri`)
};

/**
* | output |
* | --- |
* | "Your own subscription" |
*
* @param {Serve_Page_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_page_overline = /** @type {((inputs?: Serve_Page_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Page_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_page_overline(inputs)
	return en_serve_page_overline(inputs)
});